
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[type]/[[...facetId]]",
      function () {
        return require("private-next-pages/[type]/[[...facetId]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[type]/[[...facetId]]"])
      });
    }
  